module.exports = __webpack_public_path__ + "static/img/__9469.9e7a037.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/__9469.jpg
// module id = 2dN6
// module chunks = 0